videojs.addLanguage('fr', {
  "save": "Enregistrer",
  "editMode": "Mode Edition",
  "previewMode": "Visualisation"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_sous_titrage/dist/lang/fr.js
// module id = 574
// module chunks = 1